import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  correctionService,
  type CorrectionRequest,
  type CorrectionResult,
} from '@/services/CorrectionService';

export const useCompleteCorrection = () => {
  const queryClient = useQueryClient();

  return useMutation<CorrectionResult, Error, CorrectionRequest>({
    mutationFn: async (request) => {
      return correctionService.completeCorrection(request);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['transaction-log'] });
      void queryClient.invalidateQueries({ queryKey: ['entities'] });
    },
  });
};
